/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Period_DayInputs */

const en_plan_period_day = /** @type {(inputs: Plan_Period_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`day`)
};

const es_plan_period_day = /** @type {(inputs: Plan_Period_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`día`)
};

/**
* | output |
* | --- |
* | "day" |
*
* @param {Plan_Period_DayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_period_day = /** @type {((inputs?: Plan_Period_DayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Period_DayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_period_day(inputs)
	return en_plan_period_day(inputs)
});